import { SeverityLevel } from '@sentry/types';

import { getInitialData } from 'utils/getInitialData';

const environment = getInitialData('buildEnv', 'dev');

class Logger {
  hub!: Errno;

  constructor() {
    if (typeof window !== 'undefined' && window.Errno) {
      const hub = new window.Errno({
        ignoreErrors: [
          'yaCounter',
          'window.cb',
          'VK is not defined',
          '__ym__prom',
          'Network Error',
          'Failed to fetch',
          'Load failed',
          'NetworkError when attempting to fetch resource',
          'The operation was aborted',
          'AbortError',
          /Loading chunk .* failed/,
          /Loading CSS chunk .* failed/,
          'QuotaExceededError',
          'SecurityError',
          'The operation is insecure',
          'Permissions::query does not support',
          'Non-Error promise rejection',
          'timeout exceeded',
          'Request aborted',
          'signal timed out',
        ],
        denyUrls: [/ssi\/templates\/deals-ssi/, /userscript/, /drivers-kit/, /static\/header\/header.js/, /gtm\.js/i],
        dsn: 'https://586e091b44614bef907063e9411640fb@s1.ati.su/84',
        environment,
        release: `${process.env.APP_NAME}@${process.env.RELEASE_COMMIT}`,
        sampleRate: 0.1,
        tracesSampleRate: 0.01,
        autoSessionTracking: false,
        integrations: [
          // @ts-expect-error BrowserTracing does not exist
          // скорее всего из-за разных версий глобального бандла и локального пакета
          new window.Sentry.Integrations.BrowserTracing(),
        ],
      });

      this.hub = hub;
    }
  }

  log = (message: string, level?: SeverityLevel) => {
    try {
      this.hub?.captureMessage(message, level);
    } catch (error) {}
  };

  error = (exception: Error, context?: TErrnoOptions) => {
    try {
      this.hub?.captureException(exception, context);
    } catch (error) {}
  };
}

export default new Logger();
